import { Col, Form, Select } from "antd";
import {
  BUYER_INQUIRY_LIST_ENDPOINT,
  GET_STYLE_LIST_ENDPOINT,
  SUBSTYLE_LIST,
} from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useEffect, useState } from "react";
import { isArrayAndHasValue, renderSubstyleName } from "utils/functions";

const OBFilterFields = ({
  initialTableData,
  onChangeSubStyle,
  style_id_watch,
  view,
  manpowerMode,
}) => {
  // States
  const [buyerInquiryList, setBuyerInquiryList] = useState(null);
  const [styleList, setStyleList] = useState(null);
  const [subStyleList, setSubStyleList] = useState(null);

  // Antd
  const { Option } = Select;

  // Effects
  useEffect(() => {
    // Get buyer inquiry, style and substyle on first load
    getBuyerInquiryList();
    getStyleList();
    getSubStyles();
  }, []);

  const getBuyerInquiryList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(
      BUYER_INQUIRY_LIST_ENDPOINT,
      false,
      bodyData,
    );

    if (response && response?.data?.code === 200) {
      setBuyerInquiryList(response?.data?.data?.data || []);
    }
  };

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(GET_STYLE_LIST_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };

  const getSubStyles = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      page: filterValues?.page || 1,
      ...filterValues,
    };
    const query = `${SUBSTYLE_LIST}`;

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSubStyleList(response?.data?.data?.data || []);
    }
  };

  return (
    <>
      <Col span={4}>
        <Form.Item label="Inquiry ID" name="inquiry_id">
          <Select
            showSearch
            placeholder="Select a Buyer Inquiry"
            onSearch={(value) => {
              getBuyerInquiryList({ inquiry_no: value });
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => getBuyerInquiryList()}
          >
            {isArrayAndHasValue(buyerInquiryList) &&
              buyerInquiryList.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.inquiry_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Style ID" name="style_id">
          <Select
            showSearch
            placeholder="Select a Style"
            onSearch={(value) => {
              getStyleList({ style_no: value });
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => getStyleList()}
          >
            {isArrayAndHasValue(styleList) &&
              styleList.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Sub Style" name="sub_style_id">
          <Select
            onSelect={(value) => onChangeSubStyle && onChangeSubStyle(value)}
            onSearch={(value) =>
              getSubStyles({
                sub_style_no: value,
                style_id: style_id_watch || null,
              })
            }
            showSearch
            style={{
              width: "100%",
            }}
            placeholder="Search to Select"
            optionFilterProp="children"
            size="small"
            disabled={view || manpowerMode}
            allowClear
            onClear={getSubStyles}
          >
            {isArrayAndHasValue(subStyleList) &&
              subStyleList?.map((item) => (
                <Option
                  key={item?.id}
                  value={item?.id}
                  label={item?.sub_style_no}
                >
                  {renderSubstyleName(item)}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default OBFilterFields;
